/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ loadText: NonNullable<unknown>, reps: NonNullable<unknown> }} Workout_Logging_Warmup_SetInputs */

const en_us2_workout_logging_warmup_set = /** @type {(inputs: Workout_Logging_Warmup_SetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.loadText} × ${i?.reps}`)
};

const pt_br2_workout_logging_warmup_set = /** @type {(inputs: Workout_Logging_Warmup_SetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.loadText} × ${i?.reps}`)
};

const es_419_workout_logging_warmup_set = /** @type {(inputs: Workout_Logging_Warmup_SetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.loadText} × ${i?.reps}`)
};

const pt_pt2_workout_logging_warmup_set = /** @type {(inputs: Workout_Logging_Warmup_SetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.loadText} × ${i?.reps}`)
};

const fr_fr2_workout_logging_warmup_set = /** @type {(inputs: Workout_Logging_Warmup_SetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.loadText} × ${i?.reps}`)
};

const de_de2_workout_logging_warmup_set = /** @type {(inputs: Workout_Logging_Warmup_SetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.loadText} × ${i?.reps}`)
};

const it_it2_workout_logging_warmup_set = /** @type {(inputs: Workout_Logging_Warmup_SetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.loadText} × ${i?.reps}`)
};

/**
* | output |
* | --- |
* | "{loadText} × {reps}" |
*
* @param {Workout_Logging_Warmup_SetInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_logging_warmup_set = /** @type {((inputs: Workout_Logging_Warmup_SetInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Logging_Warmup_SetInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_logging_warmup_set(inputs)
	if (locale === "es-419") return es_419_workout_logging_warmup_set(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_logging_warmup_set(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_logging_warmup_set(inputs)
	if (locale === "de-DE") return de_de2_workout_logging_warmup_set(inputs)
	if (locale === "it-IT") return it_it2_workout_logging_warmup_set(inputs)
	return en_us2_workout_logging_warmup_set(inputs)
});
export { workout_logging_warmup_set as "workout-logging.warmup_set" }